// src/moment/components/Jokes/Countdown.tsx

import { FC, useState, useEffect, useMemo } from 'react';
import './Countdown.scss';

// ADDED: Export the interface for use in tests and stories
export interface CountdownProps {
  duration: number; // The total time for the countdown in seconds
  onComplete: () => void; // A function to call when the countdown finishes
  className?: string;
}

const CIRCUMFERENCE = 2 * Math.PI * 45;

const Countdown: FC<CountdownProps> = ({ duration, onComplete, className }) => {
  // ... component logic remains the same
  const [count, setCount] = useState(duration);
  const [isVanishing, setIsVanishing] = useState(false);

  const initialDuration = useMemo(() => duration, [duration]);

  useEffect(() => {
    if (count <= 0) {
      setIsVanishing(true);
      const timer = setTimeout(() => {
        onComplete();
      }, 500);
      return () => clearTimeout(timer);
    }

    const interval = setInterval(() => {
      setCount((prevCount) => prevCount - 1);
    }, 1000);

    return () => clearInterval(interval);
  }, [count, onComplete]);

  const progress = (initialDuration - count) / initialDuration;
  const dashOffset = CIRCUMFERENCE * (1 - progress);

  return (
    <div
      className={`countdown ${className || ''} ${
        isVanishing ? 'is-vanishing' : ''
      }`}
    >
      <div className="countdown__timer">
        <svg className="countdown__svg" viewBox="0 0 100 100">
          <circle className="countdown__svg-track" cx="50" cy="50" r="45" />
          <circle
            className="countdown__svg-progress"
            cx="50"
            cy="50"
            r="45"
            style={{ strokeDashoffset: dashOffset }} // Apply style dynamically
          />
        </svg>
        <span key={count} className="countdown__number">
          {count > 0 ? count : 0}
        </span>
      </div>
    </div>
  );
};

export default Countdown;
